export const PRIMARY_COLOR = "#A9D342";
export const PRIMARY_COLOR_HOVER = "#8AB835";
export const SECONDARY_COLORS = ["#60A5FA", "#F59E0B", "#EF4444", "#8B5CF6"];
export const CURRENCY_COLORS = [
  "#A9D342",
  "#60A5FA",
  "#F472B6",
  "#FBBF24",
  "#A78BFA",
  "#34D399",
  "#FB923C",
  "#38BDF8",
  "#F87171",
  "#818CF8",
  "#10B981",
  "#F43F5E",
  "#2DD4BF",
  "#EAB308",
];

export const GEO_URL = "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";

export const CHART_AXIS_TICK = { fill: "#a1a1aa", fontSize: 10 };
export const CHART_GRID_STROKE = "#27272A";
export const CHART_CURSOR = { fill: "rgba(169, 211, 66, 0.1)" };
